import React from 'react'
import { SVGProps } from 'react'

const FileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M14.5018 1.58025C12.5077 -0.52675 9.26289 -0.52675 7.26845 1.58025L1.0682 8.13122C-0.356145 9.63631 -0.356051 12.0852 1.06839 13.5902C1.78067 14.3428 2.71598 14.719 3.65167 14.7189C4.58711 14.7188 5.52292 14.3427 6.23507 13.5902L11.9184 7.58514C12.3325 7.14772 12.5606 6.56611 12.5606 5.94749C12.5606 5.32883 12.3327 4.74726 11.9185 4.3097C11.0638 3.4067 9.67304 3.40673 8.81848 4.30987L5.10176 8.23675C4.81642 8.5382 4.81642 9.02703 5.1017 9.32855C5.38701 9.6301 5.84967 9.63 6.13504 9.32855L9.85179 5.40164C10.1367 5.10061 10.6002 5.10055 10.8851 5.40157C11.0231 5.54738 11.0992 5.74126 11.0992 5.94745C11.0992 6.15365 11.0232 6.34747 10.8851 6.49334L5.20173 12.4984C4.34701 13.4013 2.95639 13.4015 2.10173 12.4984C1.24707 11.5954 1.24701 10.126 2.10157 9.22292L8.30179 2.67205C9.72636 1.16697 12.0441 1.16697 13.4685 2.67205C14.1586 3.40109 14.5386 4.37046 14.5386 5.4015C14.5386 6.43255 14.1585 7.40192 13.4685 8.13102L7.26836 14.6821C6.98304 14.9836 6.98304 15.4724 7.26842 15.7739C7.41111 15.9247 7.59811 16 7.78507 16C7.97207 16 8.15907 15.9246 8.30176 15.7739L14.5018 9.22286C15.4679 8.20218 15.9999 6.84508 16 5.40154C16 3.95803 15.4679 2.60093 14.5018 1.58025Z" />
    </g>
  </svg>
)
export default FileIcon
